import { AssetIcon } from 'assets/icons/AssetIcon';
import React, { HtmlHTMLAttributes } from 'react';
import './start-page-button-icons.css';

export type StartPageButtonIconsProps =
  HtmlHTMLAttributes<HTMLImageElement> & {};

const StartPageButtonIcons: React.FC<StartPageButtonIconsProps> = () => (
  <div className="start-page_icon-group">
    <span className="start-page_icon-item">
      <AssetIcon.CameraIcon />
    </span>
    <span className="start-page_icon-item">
      <AssetIcon.PhotoBoothIcon />
    </span>
    <span className="start-page_icon-item">
      <AssetIcon.PictureIcon />
    </span>
    <span className="start-page_icon-item">
      <AssetIcon.PhotoSheetIcon />
    </span>
  </div>
);

export default StartPageButtonIcons;
